import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (!measurementId) {
    console.warn('GA Measurement ID is not provided');
    return;
  }

  // For testing - enable in development too
  // if (process.env.NODE_ENV === 'development') {
  //   console.log('GA disabled in development mode');
  //   return;
  // }

  try {
    ReactGA.initialize(measurementId);
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
  }
};

// Track page views
export const trackPageView = (path) => {
  // For testing - still log in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[GA] Page view tracked: ${path}`);
    // Don't return early for testing
    // return;
  }
  
  try {
    ReactGA.send({ hitType: 'pageview', page: path });
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  // For testing - still log in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[GA] Event tracked: ${category} / ${action} / ${label} / ${value}`);
    // Don't return early for testing
    // return;
  }
  
  try {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};
